// extracted by mini-css-extract-plugin
export default {"cls1":"InferenceInspectorPage-Outputs-module--cls1--E0kl5","cls2":"InferenceInspectorPage-Outputs-module--cls2--Dqxq2 InferenceInspectorPage-Outputs-module--cls1--E0kl5"};